var map = {
	"./icons/add.svg": "./resources/svg/icons/add.svg",
	"./icons/apple.svg": "./resources/svg/icons/apple.svg",
	"./icons/arrow-down.svg": "./resources/svg/icons/arrow-down.svg",
	"./icons/arrow-left.svg": "./resources/svg/icons/arrow-left.svg",
	"./icons/arrow-right.svg": "./resources/svg/icons/arrow-right.svg",
	"./icons/arrow-up-right.svg": "./resources/svg/icons/arrow-up-right.svg",
	"./icons/at.svg": "./resources/svg/icons/at.svg",
	"./icons/attachment.svg": "./resources/svg/icons/attachment.svg",
	"./icons/calendar.svg": "./resources/svg/icons/calendar.svg",
	"./icons/checkmark-circle.svg": "./resources/svg/icons/checkmark-circle.svg",
	"./icons/checkmark.svg": "./resources/svg/icons/checkmark.svg",
	"./icons/chevron-down.svg": "./resources/svg/icons/chevron-down.svg",
	"./icons/chevron-up.svg": "./resources/svg/icons/chevron-up.svg",
	"./icons/close.svg": "./resources/svg/icons/close.svg",
	"./icons/discord.svg": "./resources/svg/icons/discord.svg",
	"./icons/download.svg": "./resources/svg/icons/download.svg",
	"./icons/dribbble.svg": "./resources/svg/icons/dribbble.svg",
	"./icons/enlarge.svg": "./resources/svg/icons/enlarge.svg",
	"./icons/external.svg": "./resources/svg/icons/external.svg",
	"./icons/facebook-round.svg": "./resources/svg/icons/facebook-round.svg",
	"./icons/facebook-square.svg": "./resources/svg/icons/facebook-square.svg",
	"./icons/fb-messenger.svg": "./resources/svg/icons/fb-messenger.svg",
	"./icons/google.svg": "./resources/svg/icons/google.svg",
	"./icons/home.svg": "./resources/svg/icons/home.svg",
	"./icons/instagram.svg": "./resources/svg/icons/instagram.svg",
	"./icons/linkedin.svg": "./resources/svg/icons/linkedin.svg",
	"./icons/mail.svg": "./resources/svg/icons/mail.svg",
	"./icons/map.svg": "./resources/svg/icons/map.svg",
	"./icons/notification.svg": "./resources/svg/icons/notification.svg",
	"./icons/phone-ringing.svg": "./resources/svg/icons/phone-ringing.svg",
	"./icons/phone.svg": "./resources/svg/icons/phone.svg",
	"./icons/pin.svg": "./resources/svg/icons/pin.svg",
	"./icons/pinterest.svg": "./resources/svg/icons/pinterest.svg",
	"./icons/play.svg": "./resources/svg/icons/play.svg",
	"./icons/send.svg": "./resources/svg/icons/send.svg",
	"./icons/skype.svg": "./resources/svg/icons/skype.svg",
	"./icons/snapchat.svg": "./resources/svg/icons/snapchat.svg",
	"./icons/spotify.svg": "./resources/svg/icons/spotify.svg",
	"./icons/star.svg": "./resources/svg/icons/star.svg",
	"./icons/thumbs-up.svg": "./resources/svg/icons/thumbs-up.svg",
	"./icons/tiktok.svg": "./resources/svg/icons/tiktok.svg",
	"./icons/twitch.svg": "./resources/svg/icons/twitch.svg",
	"./icons/twitter.svg": "./resources/svg/icons/twitter.svg",
	"./icons/warning.svg": "./resources/svg/icons/warning.svg",
	"./icons/whatsapp.svg": "./resources/svg/icons/whatsapp.svg",
	"./icons/youtube.svg": "./resources/svg/icons/youtube.svg",
	"./icons/zoom.svg": "./resources/svg/icons/zoom.svg",
	"./rima-trans.svg": "./resources/svg/rima-trans.svg",
	"./vv.svg": "./resources/svg/vv.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./resources/svg sync recursive ^\\.\\/.*$";